import { render, staticRenderFns } from "./StartseiteKommunikation.vue?vue&type=template&id=387b5454"
import script from "./StartseiteKommunikation.vue?vue&type=script&lang=js"
export * from "./StartseiteKommunikation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports